import { createApp } from "vue";
import hash from "../../hash";
import html from "./seasonExclusCustomers.html";
import { dropdownFilter } from '../composant/dropdownFilter';
import { PrepareEtat, JeuDeDonnees } from '../composant/PrepareEtatV1';
import { Dropdown } from 'bootstrap';
import Store from "../../Store"; 

import Fuse from 'fuse.js'
const fuseOptions = {
    threshold: 0.0,
    keys: [
        'data.financialgroup',
        'data.category',
        'data.region',
        'data.pays',
        'data.paysV',
        'data.k',
        'data.v',
    ]
}

import { inArray } from "jquery";

function computeTitle(title, checked) {
    if (!checked.length) return title;
    if (checked.length > 6) return title + " (" + checked.length + " selected)";
    return title + " (" + checked.join(", ") + ")";
}
const js = ({
    url: function (echangeur) {
        
        let u = Store.get('getURUL')();
        if(!echangeur.hash.u) echangeur.hash.env= u; 

        echangeur.addAction('b2b.toc.editExclus', echangeur.hash, '', 'form');
        echangeur.addAction('b2b.toc.exclusclient', echangeur.hash, '', 'client');
        echangeur.addAction('b2b.toc.exclusclientEdi', echangeur.hash, '', 'clientEdi');
    },
    onLoad: function (echangeur) {
        const form = echangeur.form
        const _id = echangeur.hash._id;
        const sid = echangeur.hash.sid;
        //
        let levels = [];
        const prepareEtat = new PrepareEtat(levels, 'k');
        //echangeur.clientEdi.rows
        const jeuDeDonnees = new JeuDeDonnees(echangeur.client.rows);
        const jeuDeDonnees2 = new JeuDeDonnees(echangeur.clientEdi.rows);

        const filterListes2 = {
            financialgroup: jeuDeDonnees2.addFilterList('financialgroup'),
            region: jeuDeDonnees2.addFilterList('region'),
            pays: jeuDeDonnees2.addFilterList('pays'),
            category: jeuDeDonnees2.addFilterList('category'),
        }



        const filterListes = {
            financialgroup: jeuDeDonnees.addFilterList('financialgroup'),
            region: jeuDeDonnees.addFilterList('region'),
            pays: jeuDeDonnees.addFilterList('pays'),
            category: jeuDeDonnees.addFilterList('category'),
        }

        filterListes.financialgroup.setChecked(form.filtre.financialgroup);
        filterListes.region.setChecked(form.filtre.region);
        filterListes.pays.setChecked(form.filtre.pays);
        filterListes.category.setChecked(form.filtre.category);

        
        filterListes2.financialgroup.setChecked(form.filtre.financialgroup);
        filterListes2.region.setChecked(form.filtre.region);
        filterListes2.pays.setChecked(form.filtre.pays);
        filterListes2.category.setChecked(form.filtre.category);
        //
        function getFilter(name) {
            const a = filterListes[name];
            if (a) return a;
            window.alert("filtreFin code inconnu : " + name);
        }

        let THIS = this;
        
        const app = createApp({
            components: {
                'dropdown-filter': dropdownFilter,
            },
            data: () => ({
                form: form,
                id: _id,
                blocs: [],
                blocsEdi: [],
                isEdi : true,
                //
                fuse: null,
                searchKey: '',
                //
                checkeds: true,
                //
                dropdownFinancialGroup: { name: 'financialgroup', key: 0, list: [], checked: [], actif: false },
                dropdownRegion:      { name: 'region',   key: 0, list: [], checked: [], actif: false },
                dropdownPays:        { name: 'pays',     key: 0, list: [], checked: [], actif: false },
                dropdownCategory:    { name: 'category', key: 0, list: [], checked: [], actif: false },
                filtreActif: {},
                filtreTitre: {
                    financialgroup: computeTitle("Financial group", filterListes.financialgroup.getChecked()),
                    category: computeTitle("Category", filterListes.category.getChecked()),
                    pays: computeTitle("Country", filterListes.pays.getChecked()),
                    region: computeTitle("Region", filterListes.region.getChecked()),
                },
                activeDropdown: [],
            }),

            computed: {
                totalFilter() {
                    return this.blocs.filter(u => (u.inSearch)).length
                },
                listFilter() {
                    return this.blocs.filter(u => (u.inSearch))
                },
            },

            methods: {

                close() {
                    hash.fin();
                },

                lanceRecherche(val) {
                    const index = 'v'
                    const data = this.blocs
                    if (data && val) {
                        const searchIndex = this.fuse.search(val).map(u => u.item.data[index]);
                        data.map(u => u.inSearch = (searchIndex.includes(u.data[index])))
                    }
                },

                isselectallchecked() {
                    const affiches = (this.listFilter.length > 0) ? this.listFilter : this.blocs;
                    if (this.form.clients.length >= affiches.length) { // si on a au moins autant de clients selectionnés que d'affichés
                        let statuscb = true;
                        for (const affiche of affiches) {
                            if (!this.form.clients.includes(affiche.data.k)) {
                                statuscb = false;
                                break; // pas besoin de regarder les suivants, ils ne sont pas tous cochés
                            }
                        }
                        this.checkeds = statuscb;
                    } else {
                        this.checkeds = false;
                    }
                },
                async save() {
                    // faut chercher tous les clients affichés (this.blocs) qui sont cochés (this.form.clients) 
                    // car il peut y avoir des clients non affichés qui sont encore cochés !
                    // 
                    const clients = this.blocs.filter(u => (u.is = "DATA"))
                        .map(u => u.data)
                        .filter(u => this.form.clients.indexOf(u.k) >= 0)
                        .map(u => u.k);
                    const clientsEdi = this.blocsEdi.filter(u => (u.is = "DATA"))
                        .map(u => u.data)
                        .filter(u => this.form.clients.indexOf(u.k) >= 0)
                        .map(u => u.k);
                    //
                    
                    let financialgroup  = filterListes.financialgroup.getChecked();
                    let region          = filterListes.region.getChecked();
                    let pays            = filterListes.pays.getChecked();
                    let category        = filterListes.category.getChecked();
                    
                    const sdoc = {
                        clients: clients.concat(clientsEdi),
                        filtre: {
                            financialgroup: filterListes.financialgroup.getChecked(),
                            region:         filterListes.region.getChecked(),
                            pays:           filterListes.pays.getChecked(),
                            category:       filterListes.category.getChecked(),
                        }
                    }
 
                    sdoc.filtre.financialgroup.concat( financialgroup );
                    sdoc.filtre.category.concat( category );
                    sdoc.filtre.region.concat( region );
                    sdoc.filtre.pays.concat( pays );

 
                    const result = await THIS.rest("b2b.toc.clientSaveExclus", { "_id": _id, "sid": sid, }, sdoc);
                    //
                    if (result.ok) this.close();

                },

                clickFilter(event, item) {
                    const filter = getFilter(item.name);
                    if (filter) {
                        item.dropdown.list = filter.valeursPossibles().map(u => ({ k: u, v: u }));
                        item.dropdown.checked = filter.getChecked();
                        item.dropdown.key++; //Restart			
                    }
                    //
                    item.dropdown.close = function () { new Dropdown(event.target).hide() };
                    this.lanceFuse();
                },

                filtreFin(name, checkeds) {

                    const filter = getFilter(name);
                    filter.setChecked(checkeds);
                    this.filtreActif[name] = checkeds.length;

                    this.blocs = prepareEtat.construit(jeuDeDonnees.getRows());
                    const dropdown = this.activeDropdown.find(u => u.name == name);
                    this.filtreTitre[name] = computeTitle(dropdown.title, checkeds);
                    dropdown.dropdown.close();
                    this.isselectallchecked();

                    return
                    //
                },

                /* selectAll() {
                                   if (this.checkeds == false) for (let bloc of this.blocs) { this.form.clients.push(bloc.data.k) }
                                   if (this.checkeds == true) this.form.clients = []
                               }, */

                selectAll() {
                    if (this.checkeds == false) {
                        this.checkeds = true;
                        const checkdoublon = this.form.clients.length > 0;
                        // this.form.clients = []
                        const affiches = (this.listFilter.length > 0) ? this.listFilter : this.blocs;

                        for (let bloc of affiches) {
                            if (!checkdoublon || !this.form.clients.includes(bloc.data.k)) {
                                this.form.clients.push(bloc.data.k);
                            }
                        }

                    } else {
                        this.checkeds = false;
                        const affiches = (this.listFilter.length > 0) ? this.listFilter : this.blocs;
                        for (const bloc of affiches) {
                            const index = this.form.clients.indexOf(bloc.data.k);
                            this.form.clients.splice(index, 1);
                        }
                        //                      this.form.clients = [];
                    }
                },

                lanceFuse() {
                    this.fuse = new Fuse(this.blocs, fuseOptions);
                },

            },
            watch: {
                "searchKey"(val) {
                    this.lanceRecherche(val);
                    this.isselectallchecked();
                },
                "form.clients"() {
                    this.isselectallchecked();
                }
            },
            mounted() {

                this.blocs = prepareEtat.construit(jeuDeDonnees.getRows())
                this.blocsEdi = prepareEtat.construit(jeuDeDonnees2.getRows());
                if (this.form.clients.length == this.blocs.length) {
                    this.checkeds = true
                } else {
                    this.checkeds = false
                }

                const a = [
                    { name: "financialgroup", title: "Financial group", filter: this.clickFilterFinanialgroup, dropdown: this.dropdownFinancialGroup },
                    { name: "region", title: "Region", filter: this.clickFilterRegion, dropdown: this.dropdownRegion },
                    { name: "pays", title: "Country", filter: this.clickFilterPays, dropdown: this.dropdownPays },
                    { name: "category", title: "Category", filter: this.clickFilterCategory, dropdown: this.dropdownCategory },
                ]

                for (const g of a) {
                    const filter = getFilter(g.name)
                    if (filter) if (true) this.activeDropdown.push(g)
                }
                /*  = prepareEtat.construit(jeuDeDonnees.getRows()) */
                this.lanceFuse()

            }
        });

        app.mount(THIS.c$('._vueChargement')[0]);

    },

});

export default {
    seasonExclusCustomers: { js: js, html: html }
};